// import React, { useState, useEffect } from 'react';
// import './TrialBanner.scss';

// const TrialBanner = ({ trialDays, daysRemaining }) => {
//    const [dismissed, setDismissed] = useState(false);

//    // Calculate progress percentage (assuming 14 day trial)
//    const progressPercentage = ((trialDays - daysRemaining) / trialDays) * 100;

// //    const handleDismiss = () => {
// //       setDismissed(true);
// //       if (onDismiss) onDismiss();
// //    };

// //    const handleUpgrade = () => {
// //       if (onUpgrade) onUpgrade();
// //    };

// //    if (dismissed) return null;

//    return (
//       <div className="caredaily-rm-trial-banner">
//          <div className="caredaily-rm-trial-banner-left">
//             <span className="caredaily-rm-trial-badge">
//                <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
//                   <circle cx="12" cy="12" r="10" />
//                   <polyline points="12,6 12,12 16,14" />
//                </svg>
//                FREE TRIAL
//             </span>
//             <span className="caredaily-rm-trial-text">
//                You have <strong>{daysRemaining} days</strong> remaining in your free trial
//             </span>

//                <div className="caredaily-rm-trial-progress">
//                   <div className="caredaily-rm-progress-bar">
//                      <div className="caredaily-rm-progress-fill" style={{ width: `${100 - progressPercentage}%` }} />
//                   </div>
//                   <span className="caredaily-rm-progress-text">
//                      {daysRemaining}/{trialDays} days left
//                   </span>
//                </div>



//                <div className="caredaily-rm-trial-countdown">
//                   <div className="caredaily-rm-countdown-item">
//                      <div className="caredaily-rm-countdown-value">{daysRemaining}</div>
//                      <div className="caredaily-rm-countdown-label">Days</div>
//                   </div>
//                   <span className="caredaily-rm-countdown-separator">:</span>
//                   <div className="caredaily-rm-countdown-item">
//                      <div className="caredaily-rm-countdown-value">00</div>
//                      <div className="caredaily-rm-countdown-label">Hours</div>
//                   </div>
//                   <span className="caredaily-rm-countdown-separator">:</span>
//                   <div className="caredaily-rm-countdown-item">
//                      <div className="caredaily-rm-countdown-value">00</div>
//                      <div className="caredaily-rm-countdown-label">Mins</div>
//                   </div>
//                </div>

//          </div>

//          <div className="caredaily-rm-trial-actions">
//             {/* <button className="caredaily-rm-trial-dismiss" onClick={handleDismiss}>
//                Dismiss
//             </button>
//             <button className="caredaily-rm-trial-cta" onClick={handleUpgrade}>
//                <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
//                   <path d="M13 2L3 14h9l-1 8 10-12h-9l1-8z" />
//                </svg>
//                Upgrade Now
//             </button> */}
//          </div>
//       </div>
//    );
// };

// export default TrialBanner;

import React, { useState, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useHistory } from 'react-router-dom';
import { trailAddUser } from '../../../actions/subscriptionAction';
import './TrialBanner.scss';

const TrialBanner = ({ 
   trialDays = 15, 
   daysRemaining = null, 
   isTrialActive = false,
   onStartTrial,
   onUpgrade 
}) => {
   const dispatch = useDispatch();
   const history = useHistory();
   const [dismissed, setDismissed] = useState(false);
   const [showTrialModal, setShowTrialModal] = useState(false);
   const [countdown, setCountdown] = useState({ hours: 0, mins: 0, secs: 0 });

   const settingsData = useSelector((state) => state.subscriptionData.settingData);
   const myProfile = useSelector((state) => state.myProfile.addViewData);

   // Calculate if user has active trial
   const hasActiveTrial = myProfile?.allinOne?.status === 1 && 
                          myProfile?.allinOne?.planType === 'Trial';

   // Calculate days remaining from profile if not passed
   const calculatedDaysRemaining = daysRemaining !== null 
      ? daysRemaining 
      : (hasActiveTrial && myProfile?.allinOne?.planExpiry 
         ? Math.max(0, Math.ceil((new Date(myProfile.allinOne.planExpiry) - new Date()) / (1000 * 60 * 60 * 24)))
         : 0);

   // Calculate progress percentage
   const progressPercentage = hasActiveTrial 
      ? ((trialDays - calculatedDaysRemaining) / trialDays) * 100 
      : 0;

   // Countdown timer effect
   useEffect(() => {
      if (!hasActiveTrial || !myProfile?.allinOne?.planExpiry) return;

      const updateCountdown = () => {
         const now = new Date();
         const expiry = new Date(myProfile.allinOne.planExpiry);
         const diff = expiry - now;

         if (diff <= 0) {
            setCountdown({ hours: 0, mins: 0, secs: 0 });
            return;
         }

         const totalHours = Math.floor(diff / (1000 * 60 * 60));
         const hours = totalHours % 24;
         const mins = Math.floor((diff % (1000 * 60 * 60)) / (1000 * 60));
         const secs = Math.floor((diff % (1000 * 60)) / 1000);

         setCountdown({ hours, mins, secs });
      };

      updateCountdown();
      const interval = setInterval(updateCountdown, 1000);

      return () => clearInterval(interval);
   }, [hasActiveTrial, myProfile?.allinOne?.planExpiry]);

   const handleDismiss = () => {
      setDismissed(true);
      sessionStorage.setItem('trialBannerDismissed', 'true');
   };

   const handleStartTrial = () => {
      if (onStartTrial) {
         onStartTrial();
      } else {
         setShowTrialModal(true);
      }
   };

   const handleConfirmTrial = () => {
      dispatch(trailAddUser());
      setShowTrialModal(false);
      window.location.reload();
   };

   const handleUpgrade = () => {
      if (onUpgrade) {
         onUpgrade();
      } else {
         history.push('/subscriptions');
      }
   };

   // Check if banner was dismissed this session
   useEffect(() => {
      const wasDismissed = sessionStorage.getItem('trialBannerDismissed');
      if (wasDismissed === 'true') {
         setDismissed(true);
      }
   }, []);

   if (dismissed) return null;

   // ACTIVE TRIAL BANNER
   if (hasActiveTrial) {
      return (
         <>
            <div className="caredaily-rm-trial-banner caredaily-rm-trial-banner--active">
               <div className="caredaily-rm-trial-banner-left">
                  <span className="caredaily-rm-trial-badge caredaily-rm-trial-badge--active">
                     <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                        <circle cx="12" cy="12" r="10" />
                        <polyline points="12,6 12,12 16,14" />
                     </svg>
                     FREE TRIAL ACTIVE
                  </span>
                  <span className="caredaily-rm-trial-text">
                     You have <strong>{calculatedDaysRemaining} days</strong> remaining in your free trial
                  </span>

                  <div className="caredaily-rm-trial-progress">
                     <div className="caredaily-rm-progress-bar">
                        <div 
                           className="caredaily-rm-progress-fill" 
                           style={{ width: `${100 - progressPercentage}%` }} 
                        />
                     </div>
                     <span className="caredaily-rm-progress-text">
                        {calculatedDaysRemaining}/{trialDays} days left
                     </span>
                  </div>

                  <div className="caredaily-rm-trial-countdown">
                     <div className="caredaily-rm-countdown-item">
                        <div className="caredaily-rm-countdown-value">{calculatedDaysRemaining}</div>
                        <div className="caredaily-rm-countdown-label">Days</div>
                     </div>
                     <span className="caredaily-rm-countdown-separator">:</span>
                     <div className="caredaily-rm-countdown-item">
                        <div className="caredaily-rm-countdown-value">
                           {String(countdown.hours).padStart(2, '0')}
                        </div>
                        <div className="caredaily-rm-countdown-label">Hours</div>
                     </div>
                     <span className="caredaily-rm-countdown-separator">:</span>
                     <div className="caredaily-rm-countdown-item">
                        <div className="caredaily-rm-countdown-value">
                           {String(countdown.mins).padStart(2, '0')}
                        </div>
                        <div className="caredaily-rm-countdown-label">Mins</div>
                     </div>
                  </div>
               </div>

               <div className="caredaily-rm-trial-actions">
                  <button className="caredaily-rm-trial-dismiss" onClick={handleDismiss}>
                     Dismiss
                  </button>
                  <button className="caredaily-rm-trial-cta" onClick={handleUpgrade}>
                     <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                        <path d="M13 2L3 14h9l-1 8 10-12h-9l1-8z" />
                     </svg>
                     Upgrade Now
                  </button>
               </div>
            </div>
         </>
      );
   }

   // START FREE TRIAL BANNER (when Trailstatus === 1 and no active trial)
   return (
      <>
         <div className="caredaily-rm-trial-banner caredaily-rm-trial-banner--promo">
            <div className="caredaily-rm-trial-banner-left">
               <span className="caredaily-rm-trial-badge caredaily-rm-trial-badge--promo">
                  <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                     <polygon points="12 2 15.09 8.26 22 9.27 17 14.14 18.18 21.02 12 17.77 5.82 21.02 7 14.14 2 9.27 8.91 8.26 12 2" />
                  </svg>
                  LIMITED OFFER
               </span>
               <span className="caredaily-rm-trial-text caredaily-rm-trial-text--promo">
                  <strong>Try Care Management FREE for {trialDays} days!</strong>
                  <span className="caredaily-rm-trial-subtext">
                     Full access to all features. No credit card required.
                  </span>
               </span>

               <div className="caredaily-rm-trial-features">
                  <div className="caredaily-rm-feature-item">
                     <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                        <polyline points="20 6 9 17 4 12" />
                     </svg>
                     Client Management
                  </div>
                  <div className="caredaily-rm-feature-item">
                     <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                        <polyline points="20 6 9 17 4 12" />
                     </svg>
                     Care Plans
                  </div>
                  <div className="caredaily-rm-feature-item">
                     <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                        <polyline points="20 6 9 17 4 12" />
                     </svg>
                     Visit Scheduling
                  </div>
               </div>
            </div>

            <div className="caredaily-rm-trial-actions">
               <button className="caredaily-rm-trial-dismiss" onClick={handleDismiss}>
                  Maybe Later
               </button>
               <button className="caredaily-rm-trial-cta caredaily-rm-trial-cta--start" onClick={handleStartTrial}>
                  <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                     <polygon points="5 3 19 12 5 21 5 3" />
                  </svg>
                  Start Free Trial
               </button>
            </div>
         </div>

         {/* Trial Start Confirmation Modal */}
         {showTrialModal && (
            <div className="caredaily-rm-modal-overlay" onClick={() => setShowTrialModal(false)}>
               <div className="caredaily-rm-modal" onClick={e => e.stopPropagation()}>
                  <div className="caredaily-rm-modal-header">
                     <h2>Start Your Free Trial</h2>
                     <button className="caredaily-rm-modal-close" onClick={() => setShowTrialModal(false)}>
                        <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                           <line x1="18" y1="6" x2="6" y2="18" />
                           <line x1="6" y1="6" x2="18" y2="18" />
                        </svg>
                     </button>
                  </div>
                  <div className="caredaily-rm-modal-body">
                     <div className="caredaily-rm-trial-hero">
                        <div className="caredaily-rm-trial-hero-icon">
                           <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                              <polygon points="13 2 3 14 12 14 11 22 21 10 12 10 13 2" />
                           </svg>
                        </div>
                        <h3>{trialDays} Days of Full Access</h3>
                        <p>Experience integrated care management alongside your existing document packages.</p>
                     </div>
                     <div className="caredaily-rm-trial-list">
                        <div className="caredaily-rm-trial-list-item">
                           <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                              <polyline points="20 6 9 17 4 12" />
                           </svg>
                           <div>
                              <strong>Full Client Management</strong>
                              <span>Add up to 25 clients during your trial with complete profiles.</span>
                           </div>
                        </div>
                        <div className="caredaily-rm-trial-list-item">
                           <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                              <polyline points="20 6 9 17 4 12" />
                           </svg>
                           <div>
                              <strong>Care Assessments & Plans</strong>
                              <span>Complete assessments that link to your existing policy documents.</span>
                           </div>
                        </div>
                        <div className="caredaily-rm-trial-list-item">
                           <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                              <polyline points="20 6 9 17 4 12" />
                           </svg>
                           <div>
                              <strong>Visit Scheduling</strong>
                              <span>Schedule and track care visits with your existing staff members.</span>
                           </div>
                        </div>
                        <div className="caredaily-rm-trial-list-item">
                           <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                              <polyline points="20 6 9 17 4 12" />
                           </svg>
                           <div>
                              <strong>Seamless Data Transfer</strong>
                              <span>If you upgrade, all trial data transfers seamlessly.</span>
                           </div>
                        </div>
                     </div>
                     <div className="caredaily-rm-trial-notice">
                        <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                           <circle cx="12" cy="12" r="10" />
                           <line x1="12" y1="16" x2="12" y2="12" />
                           <line x1="12" y1="8" x2="12.01" y2="8" />
                        </svg>
                        <span>
                           <strong>No payment required.</strong> Your trial begins immediately and ends 
                           automatically after {trialDays} days.
                        </span>
                     </div>
                  </div>
                  <div className="caredaily-rm-modal-footer">
                     <button 
                        className="caredaily-rm-btn-secondary" 
                        onClick={() => setShowTrialModal(false)}
                     >
                        Maybe Later
                     </button>
                     <button 
                        className="caredaily-rm-btn-primary" 
                        onClick={handleConfirmTrial}
                     >
                        Start Free Trial
                     </button>
                  </div>
               </div>
            </div>
         )}
      </>
   );
};

export default TrialBanner;